module.exports = __webpack_public_path__ + "img/69-r.dd9a949a.png";